export default __webpack_public_path__ + "static/media/running.903ca2bd.mpeg";